var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmazonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF9900;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.6,485H76.4C42.6,485,15,457.4,15,423.6V76.4C15,42.6,42.6,15,76.4,15h347.2c33.8,0,61.4,27.6,61.4,61.4 v347.2C485,457.4,457.4,485,423.6,485z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.7,334.5c-2-1.8-3-3.7-3.2-5.9c0.2-4.9,2.5-7.3,7-7.3l6.5,2.6c37.3,25,78.9,39.3,124.6,42.8 c37.5-0.2,72.6-8.1,105.3-23.8l7-2.1c5.7,0,8.7,2.8,9.1,8.5c-0.2,2.9-1.5,5.3-3.8,7c-31.5,25-71,38.4-118.5,40.2 C186.8,392.2,142.1,371.4,106.7,334.5z M172,301.8c-10.7-9.7-16-24.2-16-43.6c0-48.5,36.5-72.7,109.4-72.7l-0.6-21.1 c-1.8-14.5-10.2-21.7-25.2-21.7c-15.3,1-24.9,8.7-29,23.2c-1.6,3.5-4,6-7.3,7.3l-34.9-4.4c-4.1,0-6.2-2.6-6.2-7.9 c8.8-36,35.4-55.1,79.8-57.5c51,0,76.5,25.6,76.5,76.7c0,51.1,1.3,79,4,83.6c2.6,4.6,5.4,8.9,8.4,13.1c0,1,0.5,2,1.6,3.1 c1.1,1.1,1.6,2.7,1.6,4.8c0,1.8-1.3,3.7-3.8,5.9c-2.5,2.2-6.6,5.7-12.3,10.7c-5.7,5-9.8,8.5-12.5,10.4c-2.6,2-4.8,2.9-6.6,2.9 c-3.1,0-8.3-3.7-15.5-11.1c-4.3-4.3-7.7-9.2-10.3-14.7c-16.8,18.4-37.6,27.6-62.5,27.6C195.5,316.3,182.6,311.4,172,301.8z  M237.8,279c9-2.1,15.6-6.9,19.8-14.4c4.2-7.4,6.6-14.1,7.3-20.1c0.7-6,0.9-12.3,0.7-18.9v-10.9c-37,0-55.4,12.5-55.4,37.5 c0,16.2,7.5,25.2,22.6,27L237.8,279z M365.4,365.6c0-1,0.5-2.7,1.5-5.1c1-2.4,2.5-6.6,4.5-12.6c2.1-6,3.1-10.9,3.1-14.8 c0-1.4-2.9-2.2-8.8-2.6l-24.9,2.6c-4.3,0-6.5-2-6.5-5.9c1-9.2,14-14.8,39-16.7c15.4,0,23.2,4.5,23.2,13.5c0,6.8-1.6,14.6-4.7,23.2 c-5.5,16.2-12.2,24.4-20.2,24.6C367.5,371.7,365.4,369.7,365.4,365.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonLogo);
export default __webpack_public_path__ + "static/media/AmazonLogo.ff34789c542ef8ff7d1bdcbf3c7a235b.svg";
export { ForwardRef as ReactComponent };